import React from 'react';

import HowItWorksStep1SVG from "../../components/Images/HowItWorksStep1SVG"
import HowItWorksStep2SVG from "../../components/Images/HowItWorksStep2SVG"
import HowItWorksStep3SVG from "../../components/Images/HowItWorksStep3SVG"
import HowItWorksStep4SVG from "../../components/Images/HowItWorksStep4SVG"
import  KavitaImg from "../../pages/WritersBenefit/Author/Images/Kavita.jpg"
import  WordsImg from "../../pages/WritersBenefit/Author/Images/Words.jpg"
import NewNovelDesktop from '../../pages/WritersBenefit/Author/Images/NewNovel.svg'
import DailyUploadDesktop from '../../pages/WritersBenefit/Author/Images/DailyUpload.svg'
import CompletionBonusDesktop from '../../pages/WritersBenefit/Author/Images/CompletionBonus.svg'
import  AnandImg from "../../pages/WritersBenefit/Author/Images/Anand.jpg"
import { commonFAQ } from '../../constants';
import RevenueSvg from '../../pages/WritersBenefit/Author/Images/Revenue.svg'



const englishUS = {
  introduction_heading :'Become the writer of your dreams! ',
  create_novel_button_text: "Create A New Novel ",
  video_thumbnail_desktop: 'https://djhonz7dexnot.cloudfront.net/b79f877e7fa88aca3706e70e00bf5417411056c3.jpg',
  video_thumbnail_mobile: 'https://djhonz7dexnot.cloudfront.net/5c8662e645a9119beb8e5a513ef0200e360c05ca.jpg',
  rewards_title: <>  Rewards &amp; Benefits 🌟</>,
  rewards_para_text: <> <span> Earn min <strong>₹1 lakh</strong>  &amp; up to <strong>₹10 lakhs</strong>   per book per year  </span> </>,
  rewardsAndBenefitsArray: [
    {
      heading: 'New Story Bonus 🖋️',
      subHeading: <>This reward is given to every signed original story when you publish the minimum words</>,
      tableHeadings: ['Minimum Words ', 'Reward 💰'],
      table: [
        {
          wordCount: '30,000',
          reward: '₹3000',
        },
      ],
      note: <>No Copied or Adult Content</>,
      extraNotes: [
        {
          no: 1,
          text: 'The writer must apply for the Writer Benefit Program [WBP] and sign the contract.',
        },
        {
          no: 2,
          text: 'The contract can be signed as early as 30,000 words ',
        },
        {
          no: 3,
          text: 'After signing, if the book meets our minimum content quality standards, it will be approved for the payment cycle starting in the 1st week of next month',
        },
      ],
    },
    {
      heading: 'Daily Update Bonus ⭐',
      subHeading: 'This reward will be based on published quantity & quality every month',
      tableHeadings: ['Word Count (Monthly)', 'Reward 💰'],
      table: [
        {
          wordCount: 'Less than 30,000  ',
          reward: 'No payment',
        },
        {
          wordCount: '30,000 - 50,000 ',
          reward: '₹2000',
        },
        {
          wordCount: ' More than 50,000   ',
          reward: '₹6000',
        },
       
      ],
      note: <>The writer can <strong>miss publishing</strong> chapters for a <strong>maximum of 5 days</strong>  in a month.</>,
      extraNotes: [
        {
          no: 1,
          text: <> After the author's writer benefit program application is approved, the eligible reward will be calculated on the 1st of every month.</>,
        },
        {
          no: 2,
          text: <> Wherein, <strong>Payment Cycle </strong>for the received reward will be on the <strong>8th of every month, </strong> given the <strong>contract is signed before the 1st of the month</strong></>,
        },
      ],
    },
    {
      heading: 'Completion Bonus 🚀',
      subHeading: 'This reward will be given to the author when the author requests to complete the story ',
      tableHeadings: ['Word Count (Overall)', 'Reward 💰'],
      table: [
        {
          wordCount: 'Less than 2,50,000   ',
          reward: 'No Payment',
        },
        {
          wordCount: '2,50,000 - 3,50,000',
          reward: '₹5000',
        },
        {
          wordCount: '3,50,000 - 5,00,000',
          reward: '₹10,000',
        },
        {
          wordCount: ' More than  5,00,000 ',
          reward: '₹25,000',
        },
      ],
      note: <>The story should have a satisfying ending </>,
      extraNotes: [
        {
          no: 1,
          text: <> Send an email to our official account : writers@pocketfm.com, with the subject title : &#91;Book Name&#93; &#91;Author Name&#93; Request for Completion Bonus </>,
        },
        {
          no: 2,
          text: <>The payment would be approved after an editorial check to evaluate if the book meets our content quality guidelines.</>,
        },
      ],
    },
  ],
  revenue: {
    heading: 'Min. 20% Lifetime Revenue Share',
    image: RevenueSvg,
    subHeading: <>Get recognized and rewarded for your hard work throughout your lifetime.
    <br/>
    Once your audio series is approved for the WBP Program, a world of exclusive benefits is UNLOCKED! Earn a remarkable 20% Revenue Share for every coin spent by listeners on your audio series.
    </>,
    extraNotes: [
      {
        no: 1,
        text: 'The revenue share amount will be available in your Income Tab within the 1st day of next month (post-contract execution).',
      },
      {
        no: 2,
        text: <>Only original long-format fiction stories are allowed. Any series with plagiarism ( copied content) and sexually explicit (adult content ) will be disabled by Pocket FM. Please adhere to the 
        <a href="https://writer.pocketnovel.com/content-and-community-guidelines" target="_blank"> content guidelines.</a></>
      }
    ],
  },
  new_novel_bonus: {
    heading: '1. New Series Bonus 🖋️',
    image: NewNovelDesktop,
    subHeading: <>You are eligible for this reward after the novel is approved for the WBP Program.</>,
    tableHeadings: ['Minimum Words ', 'Reward 💰'],
    table: [
      {
        wordCount: '30,000',
        reward: '$150',
      },
    ],
    note: <>NO copied, translated, adult or non-fiction content allowed </>,
    extraNotes: [
      {
        no: 1,
        text: 'The writer must apply for the Writer Benefit Program [WBP].',
      },
      {
        no: 2,
        text: <>Only audio series that meet our content quality standards will be approved. <a href="https://writer.pocketnovel.com/content-and-community-guidelines" target="_blank">Content Guidelines</a></>
      },
      {
        no: 3,
        text: 'The reward will be added to the “Income Tab” post-approval.',
      },
      {
        no: 4,
        text: <>The reward amount will be proportionately calculated based on words published at approval time.<br/>Example: If at the time of approval, the novel has 50,000 words, then the reward will be $250</>,
      },
      {
        no: 5,
        text: "Transfer from writer's wallet to bank account will be initiated post signing of the contract. Payment will be processed on a monthly basis. The first payment starts in the 2nd week of the preceding month of contract execution.",
      },
      {
        no: 6,
        text: "Pocket FM reserves the right to reject or reclaim rewards if we notice any malpractice including but not restricted to Plagiarism, explicit content, translation, etc. during our review process.",
      },
    ],
  },
  daily_update_bonus : {
    heading: '2. Daily Update Bonus ⭐',
    image: DailyUploadDesktop,
    subHeading: <>At Pocket FM, we value your commitment to sharing daily chapters with our avid listeners. To show our appreciation, we offer enticing incentives for your consistent writing. The more dedicated you are, the greater your rewards!
        <br/>
        By maintaining a writing streak and delivering up to 2000 words per day, you'll unlock daily rewards tailored to your streak state
        </>,
    tableHeadings: ['Incentive Type', 'Incentive for writing 2000 words 💰'],
    table: [
      {
        wordCount: <span style={{color: '#54B585'}} >Full Incentive</span>,
        reward: <> <span style={{color: '#54B585'}}>100%</span> of incentive <br /> = $10/day  </>,
      },
      {
        wordCount: <span style={{color: '#799E22'}} >Streak Incentive</span>,
        reward: <><span style={{color: '#799E22'}}>150%</span> of incentive <br /> = $12.5/day</>,
      },
      {
        wordCount: <span style={{color: '#F2C602'}} >Half Incentive</span>,
        reward: <><span style={{color: '#F2C602'}}>50%</span> of incentive <br /> = $5/day</>,
      },
      {
        wordCount: <span style={{color: '#E51A4D'}} >Missed Days</span>,
        reward: <><span style={{color: '#E51A4D'}}>No</span> payment</>,
      },
     
    ],
    note: <>{'If words published are <2000 on any day, the daily bonus will be proportionately adjusted'}</>,
    extraNotes: [
      {
        no: 1,
        text: <> This reward is like ‘snakes and ladders’. The incentive type for the day will be determined by how you have published after approval of the program.</>,
      },
      {
        no: 2,
        text: <> <strong>Earn Full incentive</strong> of $350 per month <br />
        For example, <br/>
        - If you have published 2000 words daily from Oct 1st to Oct 6th; You are eligible for  <strong>Full Incentive</strong> $60.</>,
      },
      {
        no: 3,
        text: <> Post approval to the program, after you publish <strong>continously</strong> for 15 days, you will receive a <strong>Streak incentive</strong>for your daily consistency.<br /> 
        For example,<br/>
        - If you have published 2000 words daily from Oct 1st till Nov 1st.;
        then from Oct 1st till Oct 15th you will get a <strong>Full Incentive</strong>  for the month amounting to $150.<br/> 
        For publishing from Oct 16th to 1st Nov, you will receive a <strong>Streak Incentive</strong>   for the 16 days = $200 ($12.5 per day). <br/>
        - This <strong>Streak Incentive</strong>  continues till you keep publishing daily</>,
      },
      {
        no: 4,
        text: <> For every day you miss publishing, you get <strong>Half Incentive</strong>  on the upcoming days<br/>
        For example, <br/>
        -  If you miss publishing on 1st Jan, you'll get a<br/>
        <strong>Half Incentive</strong>  of $5 for publishing 2000 words on 2nd Jan. <br/>
        Starting 3rd Jan, you will receive <strong>Full Incentive</strong>  again for the next 15 days. <br/>
        - If you miss publishing from 1st to 3rd Jan (3 days), you'll receive <br/>
        <strong>Half Incentive</strong>  for the next 3 days of publishing i.e. for publishing from 4th to 6th Jan. <br/>
        Starting 7th Jan, you will start receiving <strong>Full Incentive</strong> again.</>,
      },
      {
        no: 5,
        text: <> The day you miss publishing, no daily bonus will be credited.</>,
      },
    ],
    disclaimer: <></>
  },
  completion_bonus : {
    heading: '3. Completion Bonus 🚀',
    image: CompletionBonusDesktop,
    subHeading: 'Once you complete a novel, you are eligible for the Completion bonus. Our editors will review your Audio Series to ensure the novel is completed as per Pocket FM standards.',
    tableHeadings: ['Word Count (Overall)', 'Reward 💰'],
    table: [
      
      {
        wordCount: '2,50,000 - 3,50,000',
        reward: '$300',
      },
      {
        wordCount: '5,00,000 - 8,00,000',
        reward: '$500',
      },
      {
        wordCount: 'More than 8,00,000',
        reward: '$650',
      },
    ],
    note: <>If the number of readers drops drastically from your audio series, the reward earned might be as per the lower word count bucket. You can review the readers' usage trend under the Analytics Tab. </>,
    extraNotes: [
      {
        no: 1,
        text: <> For any Queries or concerns, Please email us at writersupport@pocketfm.com. The Subject: <strong> Novel Name, Author name, Request for Completion Bonus</strong></>,
      },
      {
        no: 2,
        text: <>The payment will be approved after an editorial check to evaluate if the novel meets our <a href="https://writer.pocketnovel.com/content-and-community-guidelines">content guidelines</a></>,
      },
    ],
  },
  deadline_content: <>   <span>Deadline To Enter Program </span><span role="img" aria-label="finish flag">🏁</span>   </>,
  deadline_to_enter_button: "Be a Pocket Novel Writer ",
  deadline_date:1,
  deadline_date_suffix:"",
  days_or: "days or " ,
  months_to_go:" months to go !! ",
  monthInWords:"July",
  month:7,
  year: 2023,
  deadline_subheading: 'Once part of the program, you will be eligible for all the above bonuses for lifetime',
  howItWorksArray : [
    {
      step: '1',
      instruction:<> Start your novel and convert each chapter into an audio episode using our inbuilt writer tools ✍️</>,
      stepSVG:HowItWorksStep1SVG
    },
    {
      step: '2',
      instruction:<>Complete audio episode conversions for the first 30,000 words and apply for our <strong>Writers Benefit Program</strong> Sign the Contract and receive <strong>New Series Bonus</strong> 💸 💰</>,
      stepSVG:HowItWorksStep2SVG
  
    },
    {
      step: '3',
      instruction:<>Update Chapters daily and receive <strong>Daily Update Bonus</strong> every <strong>Month</strong> 💸 💰</>,
      stepSVG:HowItWorksStep3SVG
  
    },
    {
      step: '4',
      instruction:<> Upon completion of your Audio series, receive the <strong>Completion Bonus</strong> 💰 💸</>,
      stepSVG:HowItWorksStep4SVG
  
    },
  ],
  step: "step",
  popularWritersArray : [
    {
      writerName: 'kavita verma ',
      novelName: 'Mein tere chandani',
      plays: '9.8M',
      words: '820K',
      writerImgSrc: KavitaImg,
    },
    {
      writerName: 'Words Queen',
      novelName: 'Fake Love',
      plays: '7.7M',
      words: '540K',
      writerImgSrc: WordsImg,
    },
    {
      writerName: 'Anand Usha Borkar',
      novelName: 'Megh - Ek Shraap',
      plays: '1.8M',
      words: '720K',
      writerImgSrc: AnandImg,
    },
  ],
  popular_writter: 'Popular Writers ',


  faq: <strong>Frequently Asked Questions </strong>,
  frequentlyAskedQuestionsArray : commonFAQ,
  
  write_home_earn_stable_income_text :'Write at home & Earn a stable income.',
  write_home_earn_stable_income_subheading : "Start your journey. Gain millions of reads. Earn upto INR 10 lakh per book per year.",
  create_new_novel :"Create A New Novel ",
  WritingFAQs: [
    {
      question: '1. How to register and create my Audio Series? Any tips to create an Audio Series?',
      answer: "Please follow these steps ",
      youtubeLink: 'Hs8Jq8leaoU'
    },
    {
      question: '2. What are the terms & conditions for publishing an Audio Series?',
      answer: `Only original fiction stories are allowed. We disable plagiarism ( copied content) and sexually explicit (adult content ) <a href="https://writer.pocketnovel.com/content-and-community-guidelines"> Content Guideines</a>.`,
    },
    {
      question: '3. How many words are needed to publish a chapter?',
      answer: "Each chapter must contain a minimum of 1000 words or a maximum of 5000 words. This chapter needs to be converted to an audio episode using writer tools available on the platform to publish the audio series",
    },
    {
      question: '4.  Can I write short stories or Poetry? ',
      answer: "We have observed that fiction stories have much higher readers than non-fiction and poetry. So we recommend that all writers write original fiction stories. Even if we allow writers to write short stories and poems, they are not eligible to apply for the Writers Benefit Program.",
    },
    {
      question: '5. Which languages can I write in?',
      answer: "Pocket FM audio series should be written in the English language only. We do not accept content in any other language.",
    },
    {
      question: '6. Why is my Audio Series not visible on the app?',
      answer: "Pocket FM receives hundreds of new Audio Series published daily. We are able to feature the audio series with good performance in our featured list. To feature in our app, make sure to write a long story regularly with an engaging plotline.",
    },
  ],
  ProgramFAQs: [
    {
      question: '1. What are the minimum performance guidelines for signing a Writers Benefit Contract?',
      answer: "Only the top 10% of the applications to the program are accepted, please ensure your readers are engaged with the chapters added to your Audio Series. You can refer to & compare your novel's performances against the platform's Average book data by going to Analytics Tab -> Engagement -> valid reader % vs Chapter Graph",
    },
    {
      question: "2. Why do I have to sign the Writer's Benefit contract?",
      answer: "The Writers Benefit Contract includes the terms and conditions which a writer is subject to if he/she wants to enter the Writers Benefit Program. To unlock the full spectrum of WBP advantages and ensure equitable compensation for your literary endeavors, formalizing your commitment through signing the contract becomes a pivotal step. This agreement stands as the gateway to experiencing the comprehensive benefits and recognition your creative contributions deserve.",
    },
    {
      question: '3. What is the payment structure?',
      answer: "If selected for the writer benefit program, the writer is eligible to get a Revenue Share, New Novel Bonus, Daily Update Bonus, & Completion Bonus. You can refer to respective sections in Revenue & Incentive section on the writer benefit page for detailed information.",
    },
    {
      question: '4. What is the mode of payment?',
      answer: "The Income Tab will show your rewards. The final eligible payout will be deposited in the writer’s associated bank account in the 2nd week of every month given that the payout amount is> $100 except for the new novel bonus. he New Novel bonus will be transferred in full ($75).",
    },
    {
      question: '5. How many days do I need to write, once accepted to the program?',
      answer: "For our writers, a consistent flow of quality content is paramount. To secure the Daily Update Bonus, it's essential to upload chapters daily. Please note that any missed days will result in the omission of the Daily Update Bonus. You can refer to respective sections in Revenue & Incentive section on the writer benefit page for detailed information.",
    },
    {
      question: '6. What are coins?',
      answer: `Coins are used to support the writers financially. Except for the first few chapters of a novel, all the other chapters are locked for a limited time. Coins can be used to unlock these chapters and get early access to the entire story. Please watch this video for more detailed information: <a href='https://writer.pocketnovel.com/writers-benefit' target="_blank">here</a>`,
      youtubeLink: ''
    },
    {
      question: '7. How do writers benefit from coins?',
      answer: "Authors reap the rewards, with a minimum of 20% of the Revenue earned from readers' coin expenditures on the novel flowing back to them. Explore the Revenue Share card for a deeper dive into this earning structure.",
    }
  ],
  PlatformFAQs: [
    {
      question: '1. How do I log in? How to use the app?',
      answer: `Please watch this video for a detailed description <video here>`,
    },
    {
      question: '2. How to publish a chapter?',
      answer: "If you want to add chapters to a novel/audio series on our platform, you have to log in to our writersupport@pocketfm.com or our Pocket FM mobile app. This link will help you to understand.",
      youtubeLink: ''
    },
    {
      question: '3. Can I write from outside the US?',
      answer: "Our app is available globally. We welcome all writers from all countries. But we are currently only supporting authors from the United States financially.",
    },
    {
      question: '4. How to upload the Book Cover?',
      answer: "Go to the novels, and choose the edit novel option. On the right side, there is an option to update the cover image. You can upload the book cover here and also publish the Audio Series. Our graphic team creates a special Book cover for the Top performing Audio Series and will be uploaded by Pocket FM.",
    },
  ],
  IssuesFAQs: [
    // {
    //   question: '1.Didn’t get the OTP or Face issue during logging in?',
    //   answer: "Please try to get OTP on WhatsApp. If the issue still persists then mail us on <a href='mailto:writers@pocketfm.com'>writers@pocketfm.com</a> along with your login info like phone number you are trying to use.",
    // },
    {
      question: '1. Issues with email and password',
      answer: "Double-check that you have entered your username and password correctly. Remember, the password is case-sensitive. If you are still having trouble, you can use the `Forgot your Username or Password?` link to have a password reset link emailed to you on your registered email ID. If you are unable to find the email in your inbox, check your spam/junk",
    }
  ],
 
}

// console.log(hindi.writer_dream_text)
export default englishUS;
